// External libraries
import styled from '@emotion/styled';

// Internal modules
import {
  ERROR_COLOR_V3,
  getWordBreak,
  PP_FOCUS_OUTLINE_COLOR,
  PP_REACT_TOGGLE_HOVER_COLOR,
  PP_SELECTED_COLOR,
  PP_SELECTED_RANGE_COLOR,
  WHITE_COLOR,
} from '@/styles';

const ErrorContainer = styled.div`
  background-color: ${ERROR_COLOR_V3};
  border: 1px solid ${ERROR_COLOR_V3};
  border-radius: 12px;
  display: flex;
  margin-bottom: 24px;
  padding: 16px;

  div {
    padding: 2px;
  }

  div svg g :last-child {
    fill: ${WHITE_COLOR};
  }
`;

const ErrorMessage = styled.p`
  color: ${WHITE_COLOR};
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  margin-left: 8px;

  a {
    color: ${WHITE_COLOR};
    text-decoration: underline;
  }

  a:active {
    color: ${PP_REACT_TOGGLE_HOVER_COLOR};
    text-decoration: underline;
  }

  a:focus {
    box-shadow:
      ${PP_SELECTED_COLOR} 0 0 0 0.1875rem,
      ${PP_FOCUS_OUTLINE_COLOR} 0 0 0 0.5625rem;
    outline: transparent solid 0.1875rem;
    border-radius: 0.25rem;
  }

  a:hover {
    color: ${PP_SELECTED_RANGE_COLOR};
  }

  ${'' /* 27px ==> 9px margin-left + 18px width of <ErrorIcon /> */}
  ${getWordBreak('27px')}
`;

export { ErrorContainer, ErrorMessage };
